import type { CategoryConfig, IndustryCategory, RegulatoryFramework } from '../../../../types';
import type {
  ExpansionPackDefinition,
  GrowthPackDefinition,
  IndustryPackDefinition,
} from '../../../domain/industry/types';
import {
  EDTECH_MISSIONS,
  EDTECH_PRODUCTS,
  FINTECH_MISSIONS,
  FINTECH_PRODUCTS,
  FINTECH_SCENARIOS,
  getCategoryById,
  getFrameworksByCategory,
  HEALTHTECH_MISSIONS,
  HEALTHTECH_PRODUCTS,
  HEALTHTECH_SCENARIOS,
  INSURTECH_MISSIONS,
  INSURTECH_PRODUCTS,
  REGULATORY_FRAMEWORKS,
  RETAIL_MISSIONS,
  RETAIL_PRODUCTS,
  SAAS_MISSIONS,
  SAAS_PRODUCTS,
  SAAS_SCENARIOS,
} from '../../../../constants/industryCategories';

export function frameworksFor(industryId: IndustryCategory): RegulatoryFramework[] {
  if (industryId === 'sandbox') return REGULATORY_FRAMEWORKS;
  return getFrameworksByCategory(industryId);
}

export function buildPack(input: {
  id: IndustryCategory;
  version?: string;
  scenarios?: IndustryPackDefinition['scenarios'];
  products: IndustryPackDefinition['products'];
  missions: IndustryPackDefinition['missions'];
  growthPacks: GrowthPackDefinition[];
  expansionPacks?: ExpansionPackDefinition[];
}): IndustryPackDefinition {
  const category = getCategoryById(input.id);
  if (!category) {
    throw new Error(`Missing category config for ${input.id}`);
  }
  return {
    id: input.id,
    version: input.version ?? '1.0.0',
    category,
    scenarios: input.scenarios ?? [],
    products: input.products,
    missions: input.missions,
    frameworks: frameworksFor(input.id),
    growthPacks: input.growthPacks,
    expansionPacks: input.expansionPacks ?? [],
  };
}

export const PACK_CONTENT = {
  fintech: {
    scenarios: FINTECH_SCENARIOS,
    products: FINTECH_PRODUCTS,
    missions: FINTECH_MISSIONS,
  },
  healthtech: {
    scenarios: HEALTHTECH_SCENARIOS,
    products: HEALTHTECH_PRODUCTS,
    missions: HEALTHTECH_MISSIONS,
  },
  saas_b2b: {
    scenarios: SAAS_SCENARIOS,
    products: SAAS_PRODUCTS,
    missions: SAAS_MISSIONS,
  },
  insurtech: {
    scenarios: [] as IndustryPackDefinition['scenarios'],
    products: INSURTECH_PRODUCTS,
    missions: INSURTECH_MISSIONS,
  },
  edtech: {
    scenarios: [] as IndustryPackDefinition['scenarios'],
    products: EDTECH_PRODUCTS,
    missions: EDTECH_MISSIONS,
  },
  retail_ecom: {
    scenarios: [] as IndustryPackDefinition['scenarios'],
    products: RETAIL_PRODUCTS,
    missions: RETAIL_MISSIONS,
  },
} as const;

export function categoryOnlyPack(id: IndustryCategory, category: CategoryConfig): IndustryPackDefinition {
  return {
    id,
    version: '1.0.0',
    category,
    scenarios: [],
    products: [],
    missions: [],
    frameworks: frameworksFor(id),
    growthPacks: [],
    expansionPacks: [],
  };
}